export const ENUM_CONDITION = 'Condition';
export const ENUM_ACTION = 'Action';
